import { g as o } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as s, openBlock as n, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  name: "DtIconGoogleSheets",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("path", {
  d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z",
  fill: "#20A464"
}, null, -1), u = /* @__PURE__ */ e("path", {
  d: "M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z",
  fill: "#149456"
}, null, -1), f = /* @__PURE__ */ e("path", {
  d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z",
  fill: "#38AE74"
}, null, -1), m = ["fill"], p = /* @__PURE__ */ e("path", {
  d: "m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z",
  fill: "#8ED1B1"
}, null, -1), v = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16 11.75V19H8v-7.25h8Zm-4.5 1H9V14h2.5v-1.25Zm1 1.25v-1.25H15V14h-2.5Zm-1 .75H9V16h2.5v-1.25Zm1 1.25v-1.25H15V16h-2.5Zm-1 .75H9V18h2.5v-1.25Zm1 1.25v-1.25H15V18h-2.5Z",
  fill: "#fff"
}, null, -1), g = ["id"], Z = /* @__PURE__ */ e("stop", { "stop-color": "#20A464" }, null, -1), H = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#207E55"
}, null, -1), V = [
  Z,
  H
];
function A(t, S, i, I, b, a) {
  return n(), s("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--google-sheets"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Google Sheets",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _,
    u,
    f,
    e("path", {
      d: "M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, m),
    p,
    v,
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "17.265",
        y1: "12.125",
        x2: "17.265",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      }, V, 8, g)
    ])
  ], 10, c);
}
const w = /* @__PURE__ */ r(h, [["render", A]]);
export {
  w as default
};
//# sourceMappingURL=google-sheets.js.map
